import { Amplify } from 'aws-amplify';
import { getCurrentUserInfo } from './components/utils/amplifyAuthHelpers';
import { completeExternalSsoSignIn } from './components/utils/externalSsoCallback';
import { format } from 'date-fns';
import initHelpHero from 'helphero';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Route, BrowserRouter as Router, Switch, useLocation } from 'react-router-dom';
import amplifyConfig, { usingGen2Auth } from './amplifyConfig';
import { Dialog, DialogContent } from './components/ui/dialog';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './components/ui/tooltip';
import ACTIONS from './store/action';
import { Actions as ADMINACTIONS } from './store/actions/adminActions';
import { Actions as AUTHENTICATIONACTIONS } from './store/actions/authenticationActions';
import { Actions as FACILITYACTIONS } from './store/actions/facilityActions';
import { Actions as METRICACTIONS } from './store/actions/metricActions';
import { Actions as ORGANISATIONACTIONS } from './store/actions/organisationActions';
import { Actions as PAYMENTACTIONS } from './store/actions/paymentActions';
import { Actions as PROFILEACTIONS } from './store/actions/profileActions';
import { Actions as DASHBOARDACTIONS } from './store/actions/dashboardActions';
import { Actions as LEGALACTIONS } from './store/actions/legalActions';
import { applyCYFDefaultTheme } from './components/utils/ThemeUtils';
import { hasUsableSubscription } from './components/utils/subscriptionAccess';
import { X } from 'lucide-react';

import ResendConfirmationCode from './components/Register/ResendConfirmationCode.js';
import TrialBanner from './components/Register/TrialBanner.js';
import ConsultantClientAccessBanner from './components/Consultant/ConsultantClientAccessBanner.js';
import WorkingAsBanner from './components/Common/WorkingAsBanner.js';
import ShellHomeRedirect from './components/Common/ShellHomeRedirect.js';
import PlansPage from './components/Register/PlansPage.js';
import ConsumptionReport from './pages/ConsumptionReport.js';
import Dashboard from './pages/Dashboard.js';
import Developer from './pages/Developer.js';
import Facilities from './pages/Facilities.js';
import Facility from './pages/Facility.js';
import Organisation from './pages/Organisation.js';
import Organisations from './pages/Organisations.js';
import MyOrganisation from './pages/MyOrganisation.js';
import Profile from './pages/Profile.js';
import Report from './pages/Report.js';
import Reports from './pages/Reports.js';
import Usage from './pages/Usage.js';
import IntelligentImport from './pages/IntelligentImport.js';
import IntelligentImportJob from './pages/IntelligentImportJob.js';
import ConnectionsHub from './pages/ConnectionsHub.js';
import ConnectionDetail from './pages/ConnectionDetail.js';
import ConnectionOAuthReturn from './pages/ConnectionOAuthReturn.js';
import QualityHub from './pages/QualityHub.js';
import ConsultantPortfolio from './pages/ConsultantPortfolio.js';
import SharedAsksPage from './components/Consultant/SharedAsksPage.js';
import ExportIntegration from './pages/ExportIntegration.js';
import AddOnCatalog from './pages/AddOnCatalog.js';
import UsersList from './pages/UsersList.js';
import AdminPortalList from './components/AdminPortal/AdminPortalList.js';
import ClosestAirportList from './components/AdminPortal/Airports/ClosestAirportList';
import ConversionFactors from './components/AdminPortal/ConversionFactors/ConversionFactors.js';
import ClientsList from './components/AdminPortal/Organisations/OrganisationsList';
import PriceBands from './components/AdminPortal/SalesPortal/PriceBands';
import AgreementsList from './components/AdminPortal/Agreements/AgreementsList';
import NewAgreement from './components/AdminPortal/Agreements/NewAgreement';
import AgreementDetail from './components/AdminPortal/Agreements/AgreementDetail';
import IndexationRatesList from './components/AdminPortal/Indexation/IndexationRatesList';
import AgreementIndexationEvents from './components/AdminPortal/Indexation/AgreementIndexationEvents';
import PublicAgreementPage from './components/PublicAgreement/PublicAgreementPage';
import CustomerAgreementsPage from './pages/Agreements';
import TemplateVersioning from './components/AdminPortal/TemplateVersioning/TemplateVersioning';
import SettingsPage from './components/AdminPortal/Settings/Settings';
import AuditLogs from './components/AdminPortal/AuditLogs/auditLogs';
import TransferPortal from './components/AdminPortal/TransferPortal/TransferPortal';
import UsageDataList from './components/AdminPortal/UsageData/UsageDataList';
import HelpSidebar from './components/Common/HelpSidebar';
import Navbar from './components/Common/Navbar';
import Sidebar from './components/Common/Sidebar';
import VideoModal from './components/Common/VideoModal';
import { XeroAuth } from './components/Integrations/XeroAuth';
import Login from './components/Login/Login.js';
import AdminPortalModal from './components/Modals/AdminPortalModal';
import AnalysisModal from './components/Modals/AnalysisModal';
import BulkEditPage from './components/Modals/BulkEditPage';
import ConfirmationModal from './components/Modals/ConfirmationModal';
import OrgAgreementsModal from './components/Modals/OrgAgreementsModal';
import OrgModal from './components/Organisations/Modal';
import BillingPage from './components/Payments/BillingPage.js';
import RedirectUsers from './components/Register/RedirectUsers.js';
import Register from './components/Register/Register.js';
import Alert from './components/utils/Alert';
import NetZeroTable from './components/NetZero/NetZeroTable.js';
import NetZero from './components/NetZero/NetZero.js';
import UnitConverter from './pages/UnitConverter.js';
import IndustriesAndFacilityTypes from './pages/IndustriesAndFacilityTypes.js';
import OrganisationHierarchy from './components/Organisations/OrganisationHierarchy.js';
import WebFont from 'webfontloader';
import Announcement from './pages/Announcement.js';
import Theming from './pages/Theming';
import BrandShowcase from './pages/BrandShowcase';
import BrandShowcaseWhitelabel from './pages/BrandShowcaseWhitelabel';
import WfhSurveyPrototype from './pages/WfhSurveyPrototype';
import SurveyPublic from './pages/SurveyPublic';
import SurveyList from './pages/surveys/SurveyList';
import SurveyCreate from './pages/surveys/SurveyCreate';
import SurveyDetail from './pages/surveys/SurveyDetail';
import SurveyResults from './pages/surveys/SurveyResults';
import SurveyEntitlementGate from './components/Survey/admin/SurveyEntitlementGate';
import { BetaTag } from './components/Common/ReusableComponents/Reusable.js';
import ReportTemplates from './components/AdminPortal/ReportTemplates/ReportTemplates.js';
import 'react-datepicker/dist/react-datepicker.css';
import './components/UsageData/reactdatepicker.css';

let awsconfig;
try {
  // Prefer deploy-time sandbox config (infra/scripts/generate-aws-config.js) when present.
  // eslint-disable-next-line global-require, import/no-unresolved
  awsconfig = require('./aws-config');
} catch (err) {
  // Fall back to Amplify Gen2 outputs / Gen1 aws-exports via amplifyConfig below.
  awsconfig = null;
}

const resolvedAwsConfig = awsconfig && (awsconfig.default !== undefined ? awsconfig.default : awsconfig);
const usingSandboxAwsConfig = Boolean(resolvedAwsConfig && resolvedAwsConfig.aws_user_pools_id);
Amplify.configure(usingSandboxAwsConfig ? resolvedAwsConfig : amplifyConfig);

if (typeof window !== 'undefined') {
  window.__CYF_AUTH_SOURCE__ = usingSandboxAwsConfig
    ? 'sandbox-aws-config'
    : usingGen2Auth
    ? 'gen2-amplify_outputs'
    : 'gen1-aws-exports';
  // eslint-disable-next-line no-console
  console.log(`[CYF] Amplify auth config source: ${window.__CYF_AUTH_SOURCE__}`);
}

function App({
  branding,
  credentialsObtained,
  currentOrganisation,
  getAdminOrganisations,
  getLicenses,
  getMetrics,
  getOrganisationMetrics,
  getProfile,
  getUserCredentials,
  cyfAdmin,
  isFooterAgreementOpen,
  isWhiteLabelApp,
  listCountries,
  listCurrencies,
  listFacilityTypes,
  listIndustries,
  listOrganisations,
  loggedIn,
  loginWithAws,
  showFooterAgreements,
  showHelpSidebar,
  showSidebar,
  whiteLabelAdmin,
  getSubscription,
  getWLAdminSettings,
  getOrganisationUsers,
  getOrganisationPermissions,
  getUsageOptions,
  getReferralCode,
  hasSubscriptionActive,
  toggleModal,
  getTypes,
  adminPortalModal,
  adminPortalConfirmationModal,
  getEntities,
  getSubentities,
  getScope3Categories,
  notAutoClose,
  getFacilities,
  getWLSettings,
  registerPage,
  getLegalCatalogue,
  getLegalStatus,
  canEditAdminPortal,
  xeroOrSageCallback,
  checkReportingYearEndIssue,
  processingStepFunction,
  orgDetails,
  getStepFunctionStatus,
  getStripeCustomerId,
  consultantAdmin,
  toggleOrgModal,
  adminPortalTables,
  getFeatures,
  getAnnouncements,
  getTargets,
  getDashboardData,
  getDashboardComponents,
  brandingAssetPreview,
  hasContractPerm,
  canManageOrganisation,
}) {
  const { textColor, bgColor, sidebarLinkColor, sidebarBackground, tooltipBackground, tooltipText } = branding.colors || {};
  const { font: { body: appFont } = {} } = branding?.fonts?.[0] || {};
  const { name, logo, favicon } = branding || {};
  const [statusIndex, setStatusIndex] = useState(0);

  const hlp = initHelpHero('E3TB0qW4dj');

  let tourID;

  const domain = window.location.hostname.split('.')[0];
  const pathname = window.location.pathname;
  const hostname = window.location.hostname;

  switch (domain) {
    case 'app':
      tourID = 'sjKBTHOxsT';
      break;
    case 'staging':
      tourID = 'IQxudhNfKZ';
      break;
    case 'localhost':
      tourID = 'Xw8aprKcjd';
      break;
    default:
  }

  const getFaviconEl = () => document.getElementById('favicon');
  const getProjectTitle = () => document.getElementById('title');

  if (branding) {
    const icon = getFaviconEl();
    const title = getProjectTitle();
    const fav =
      brandingAssetPreview?.favicon ||
      favicon ||
      brandingAssetPreview?.logo ||
      logo;
    icon.href = fav;
    title.innerHTML = name || 'Carbon Your Footprint';
  }

  const [isModalOpen, setModalOpen] = useState(false);
  const [videoLink, setVideoLink] = useState('');

  const openModal = (link) => {
    setModalOpen(true);
    setVideoLink(link);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const canAccessWfhSurveyRoutes =
    (hasSubscriptionActive || cyfAdmin) && (!!canManageOrganisation || cyfAdmin);

  // Helper component to conditionally render beta bar
  const ConditionalBetaBar = () => {
    const location = useLocation();
    const allowedPaths = [];
    const [isHidden, setIsHidden] = useState(localStorage.getItem('hideBetaBar'));

    // Check if current path matches allowed paths
    const shouldShowBetaBar = allowedPaths.some((path) => {
      if (path === '/') {
        return location.pathname === '/' || location.pathname === '/dashboard';
      }
      return location.pathname.startsWith(path);
    });

    if (!shouldShowBetaBar || isHidden) return null;

    return (
      <div className='beta-bar'>
        <span>
          Features in{' '}
          <BetaTag color={sidebarBackground} backgroundColor={sidebarLinkColor} style={{ lineHeight: 'normal' }} /> are
          available for free with your subscription, but may incur a subscription upgrade to be accessed upon final release
        </span>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type='button'
                className='cursor-pointer p-1'
                onClick={() => {
                  localStorage.setItem('hideBetaBar', true);
                  setIsHidden(true);
                }}>
                <X size={18} strokeWidth={1.5} style={{ color: 'black' }} />
              </button>
            </TooltipTrigger>
            <TooltipContent side='top'>Hide banner</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    );
  };

  useEffect(() => {
    if (hostname.includes('worldlandtrust')) {
      WebFont.load({ google: { families: ['Quattrocento Sans:400,400i,700'] } });
    }
    if (hostname.includes('adnetzero')) {
      WebFont.load({ google: { families: ['Roboto Slab:400,400i,700'] } });
    }
  }, [hostname]);

  useEffect(() => {
    const notWLDomains = ['compareyourfootprint', 'localhost'];
    const isWL = !notWLDomains.some((d) => hostname.includes(d));
    if (!isWL) applyCYFDefaultTheme();

    (async () => {
      await getWLSettings();
      await completeExternalSsoSignIn();
      const user = await getCurrentUserInfo();
      if (user) {
        await loginWithAws(user);
        getUserCredentials();
        domain !== 'localhost' && domain !== 'dev' && hlp.identify(user?.attributes?.sub);
      }
      getLicenses();
    })();
    //eslint-disable-next-line
  }, [hostname]);

  window.onbeforeunload = function () {
    if (orgDetails && !pathname.includes('register')) {
      localStorage.setItem('Organisation', orgDetails?.id);
      localStorage.setItem('orgDetails', JSON.stringify(orgDetails));
    }
    return null;
  };

  useEffect(() => {
    if (credentialsObtained) {
      getProfile().then((profile) => {
        const { isAdmin, whiteLabelAdmin, consultantAdmin } = profile || {};
        if (isAdmin || whiteLabelAdmin || consultantAdmin) {
          getAdminOrganisations();
        }
      });
      listOrganisations();
      getMetrics();
      getScope3Categories();
      listCountries();
      listIndustries();
      listCurrencies();
      listFacilityTypes();
      getTypes();
      getEntities();
      getFeatures();
      getAnnouncements();
      const announcementInterval = setInterval(() => {
        getAnnouncements();
      }, 600000); // 600,000 ms = 10 minutes

      // Cleanup the interval when the component unmounts
      return () => clearInterval(announcementInterval);
    }
  }, [
    credentialsObtained,
    getProfile,
    getAdminOrganisations,
    listOrganisations,
    getMetrics,
    getScope3Categories,
    listCountries,
    listIndustries,
    listFacilityTypes,
    getTypes,
    getEntities,
    getFeatures,
    getAnnouncements,
    listCurrencies,
  ]);

  useEffect(() => {
    // When on the register page, we don't need to fetch all the below data, just when the app is loaded
    if (currentOrganisation && !registerPage) {
      // getProfile();
      getSubentities();
      getLegalCatalogue();
      getLegalStatus();
      getOrganisationMetrics();
      getReferralCode();
      getFacilities();
      getOrganisationUsers();
      getOrganisationPermissions();
      getDashboardComponents();
      getTargets();
      checkReportingYearEndIssue(currentOrganisation).then((o) => {
        if (o?.orgMissingCompulsoryData) {
          toggleOrgModal(true, null, 'orgMissingCompulsoryData');
        }
      });
      getWLAdminSettings();
      getStripeCustomerId().then(async (stripeCustomerId) => {
        if (stripeCustomerId) await getSubscription();
      });
    }
    //eslint-disable-next-line
  }, [currentOrganisation]);

  const { executionArn, status } = processingStepFunction || {};

  useEffect(() => {
    const newStatusIndex = statusIndex + 1;
    executionArn &&
      (!status || (status !== 'SUCCEEDED' && status !== 'FAILED')) &&
      setTimeout(async () => {
        await getStepFunctionStatus(executionArn);
        setStatusIndex(newStatusIndex);
      }, 1500);
  }, [executionArn, statusIndex, getStepFunctionStatus, status]);

  if (window.location.pathname === '/branding/whitelabel') {
    return (
      <BrandShowcaseWhitelabel />
    );
  }

  if (window.location.pathname === '/branding') {
    return (
      <BrandShowcase />
    );
  }

  if (window.location.pathname.startsWith('/agreement/')) {
    return <PublicAgreementPage />;
  }

  if (window.location.pathname.startsWith('/prototype/wfh-survey')) {
    return <WfhSurveyPrototype />;
  }

  if (window.location.pathname.startsWith('/survey/')) {
    return <SurveyPublic />;
  }

  if (!loggedIn && registerPage) {
    return (
      <Register />
    );
  } else if (!loggedIn && window.location.pathname.includes('confirmemail')) {
    return (
      <ResendConfirmationCode />
    );
  } else if (!loggedIn && window.location.pathname.includes('xero/signup')) {
    return (
      <XeroAuth />
    );
  } else if (loggedIn && registerPage) {
    return (
      <RedirectUsers />
    );
  } else if (xeroOrSageCallback) {
    return (
      <RedirectUsers xeroOrSageCallback={xeroOrSageCallback} />
    );
  } else if (!branding || Object.keys(branding).length < 1) {
    // Add loading page here while branding is being fetched
    return <RedirectUsers showLoadingPage={true} />;
  } else if (!loggedIn) {
    return (
      <Login />
    );
  }

  const pageClass = `${showSidebar ? `sidebar-l sidebar-o sidebar-o-xs` : ``} side-scroll header-navbar-fixed`;

  return (
    <TooltipProvider>
        <Router>
          <div id='container' className={`${pageClass} appContainer`} style={{ color: textColor, '--fontFamily': appFont }}>
            <Navbar />
            <Sidebar openModal={openModal} />

          <main id='main-content' style={{ minHeight: '272px' }} className={!showSidebar ? `merge-left` : ''}>
            <TrialBanner />
            <WorkingAsBanner />
            <ConsultantClientAccessBanner />
            <ShellHomeRedirect />
            <section className='wrapper' style={{ '--appBgColor': bgColor }}>
              <Alert close={notAutoClose ? toggleModal : false} />
              <Dialog open={adminPortalModal} onOpenChange={(open) => { if (!open) toggleModal(); }}>
              <DialogContent>
                  <AdminPortalModal />
                </DialogContent>
              </Dialog>
              <Dialog open={adminPortalConfirmationModal} onOpenChange={(open) => { if (!open) toggleModal(); }}>
                <DialogContent>
                  <ConfirmationModal />
                </DialogContent>
              </Dialog>
              <AnalysisModal />
              <VideoModal isOpen={isModalOpen} onClose={closeModal} link={videoLink} />
              <OrgModal />
              <Switch>
                {/* Admin Portal Tables */}
                {adminPortalTables.map((table, index) => {
                  // Tables from Admin Portal that can also be accessible for Consultant and White Label Admins
                  const nonCyfAdminTables = ['organisations', 'settings'];
                  const adminUsers = cyfAdmin || whiteLabelAdmin || consultantAdmin;
                  if (adminUsers && nonCyfAdminTables.includes(table)) {
                    if (table === 'settings') {
                      return (
                        <Route path={`/admin/${table}`} key={index}>
                          <SettingsPage />
                        </Route>
                      );
                    } else if (table === 'organisations') {
                      return (
                        <Route path={`/admin/${table}`} key={index}>
                          <ClientsList canEditAdminPortal={canEditAdminPortal} />
                        </Route>
                      );
                    }
                  } else if (cyfAdmin) {
                    return (
                      <Route path={`/admin/${table}`} key={index}>
                        <AdminPortalList canEditAdminPortal={canEditAdminPortal} />
                      </Route>
                    );
                  } else return null;
                  return null;
                })}

                {cyfAdmin && (
                  <Route path='/admin/conversionfactors'>
                    <ConversionFactors canEditAdminPortal={canEditAdminPortal} />
                  </Route>
                )}
                {cyfAdmin && (
                  <Route path='/admin/closestAirport'>
                    <ClosestAirportList />
                  </Route>
                )}
                {cyfAdmin && (
                  <Route path='/admin/usageData'>
                    <UsageDataList canEditAdminPortal={canEditAdminPortal} />
                  </Route>
                )}
                {cyfAdmin && (
                  <Route path='/admin/templates'>
                    <TemplateVersioning />
                  </Route>
                )}
                {(cyfAdmin || whiteLabelAdmin) && (
                  <Route path='/admin/theming'>
                    <Theming />
                  </Route>
                )}

                {(cyfAdmin || whiteLabelAdmin) && (
                  <Route path='/admin/announcement'>
                    <Announcement />
                  </Route>
                )}
                {cyfAdmin && (
                  <Route path='/admin/reportTemplates'>
                    <ReportTemplates />
                  </Route>
                )}
                {/* End of admin Portal Tables */}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/xero/callback'>
                    <ConnectionOAuthReturn provider='xero' />
                  </Route>
                )}
                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/sage/callback'>
                    <ConnectionOAuthReturn provider='sage' />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/connections/:connectorId'>
                    <ConnectionDetail />
                  </Route>
                )}
                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/connections'>
                    <ConnectionsHub />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/developer'>
                    <Developer />
                  </Route>
                )}

                {cyfAdmin && (
                  <Route path='/usage/:id'>
                    <BulkEditPage />
                  </Route>
                )}

                {cyfAdmin && (
                  <Route path='/admin/transferPortal'>
                    <TransferPortal />
                  </Route>
                )}

                {cyfAdmin && (
                  <Route path='/admin/auditLogs'>
                    <AuditLogs />
                  </Route>
                )}

                <Route path='/profile'>
                  <Profile />
                </Route>

                <Route path='/my-organisation'>
                  <MyOrganisation />
                </Route>

                <Route path='/organisations/:id/organisationHierarchy'>
                  <OrganisationHierarchy />
                </Route>

                <Route path='/organisations/:id'>
                  <Organisation />
                </Route>

                <Route path='/organisations'>
                  <Organisations />
                </Route>

                <Route path='/unitConverter'>
                  <UnitConverter />
                </Route>

                <Route path='/industries-and-facility-types'>
                  <IndustriesAndFacilityTypes />
                </Route>

                <Route path='/netZero/:id'>
                  <NetZero />
                </Route>

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/netZero'>
                    <NetZeroTable />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/facilities/:id'>
                    <Facility />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/facilities'>
                    <Facilities />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/intelligent-import/:id'>
                    <IntelligentImportJob />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/intelligent-import'>
                    <IntelligentImport />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/quality'>
                    <QualityHub />
                  </Route>
                )}

                {(consultantAdmin || cyfAdmin) && (
                  <Route path='/consultant'>
                    <ConsultantPortfolio />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route exact path='/shared-asks'>
                    <SharedAsksPage />
                  </Route>
                )}
                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route exact path='/shared-asks/:id'>
                    <SharedAsksPage />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/export'>
                    <ExportIntegration />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/usage'>
                    <Usage />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/consumption/:id'>
                    <ConsumptionReport />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/report/:id'>
                    <Report />
                  </Route>
                )}

                {canAccessWfhSurveyRoutes && (
                  <Route path='/surveys/:id/results'>
                    <SurveyEntitlementGate>
                      <SurveyResults />
                    </SurveyEntitlementGate>
                  </Route>
                )}

                {canAccessWfhSurveyRoutes && (
                  <Route path='/surveys/new'>
                    <SurveyEntitlementGate>
                      <SurveyCreate />
                    </SurveyEntitlementGate>
                  </Route>
                )}

                {canAccessWfhSurveyRoutes && (
                  <Route path='/surveys/:id'>
                    <SurveyEntitlementGate>
                      <SurveyDetail />
                    </SurveyEntitlementGate>
                  </Route>
                )}

                {canAccessWfhSurveyRoutes && (
                  <Route path='/surveys'>
                    <SurveyEntitlementGate>
                      <SurveyList />
                    </SurveyEntitlementGate>
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/reports'>
                    <Reports />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/users'>
                    <UsersList />
                  </Route>
                )}

                {(hasContractPerm || cyfAdmin) && (
                  <Route path='/admin/agreements/new'>
                    <NewAgreement />
                  </Route>
                )}

                {(hasContractPerm || cyfAdmin) && (
                  <Route path='/admin/agreements/:id/indexation'>
                    <AgreementIndexationEvents />
                  </Route>
                )}

                {(hasContractPerm || cyfAdmin) && (
                  <Route path='/admin/agreements/:id/edit'>
                    <NewAgreement />
                  </Route>
                )}

                {(hasContractPerm || cyfAdmin) && (
                  <Route path='/admin/agreements/:id'>
                    <AgreementDetail />
                  </Route>
                )}

                {(hasContractPerm || cyfAdmin) && (
                  <Route exact path='/admin/agreements'>
                    <AgreementsList />
                  </Route>
                )}

                {(hasContractPerm || cyfAdmin) && (
                  <Route path='/admin/indexation/rates'>
                    <IndexationRatesList />
                  </Route>
                )}

                {cyfAdmin && (
                  <Route path='/admin/sales/pricingBands'>
                    <PriceBands />
                  </Route>
                )}

                <Route path='/billing'>
                  <BillingPage />
                </Route>

                {/* Reachable without active sub so expired trials can upgrade (Phase 2 fills picker) */}
                <Route path='/plans'>
                  <PlansPage />
                </Route>

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/agreements'>
                    <CustomerAgreementsPage />
                  </Route>
                )}

                {(hasSubscriptionActive || cyfAdmin) && (
                  <Route path='/addons'>
                    <AddOnCatalog />
                  </Route>
                )}

                <Route path='/'>
                  <Dashboard hlp={hlp} tourID={tourID} />
                </Route>
              </Switch>
              {isFooterAgreementOpen && <OrgAgreementsModal />}
            </section>

            <footer style={{ background: '#fff', padding: '10px 20px', fontSize: '9px' }}>
              <span style={{ float: 'left' }}>
                {isWhiteLabelApp
                  ? 'Powered By Compare Your Footprint '
                  : `© 2016-${format(new Date(), 'yyyy')} Compare Your Footprint`}
              </span>

              <span style={{ float: 'right' }}>
                <button
                  //href={isWhiteLabelApp ? '#' : 'https://compareyourfootprint.com/privacy-policy/'}
                  onClick={() => {
                    if (isWhiteLabelApp) {
                      showFooterAgreements(true, 'privacyPolicy');
                    } else {
                      window.open('https://compareyourfootprint.com/privacy-policy/');
                    }
                  }}
                  style={{ cursor: 'pointer', border: 0, background: 'inherit' }}>
                  Privacy Policy
                </button>
              </span>

              <span style={{ float: 'right', margin: '0px 5px' }}> - </span>

              <span style={{ float: 'right' }}>
                <button
                  //href={isWhiteLabelApp ? '#' : 'https://compareyourfootprint.com/software-license-agreement/'}
                  onClick={() => {
                    if (isWhiteLabelApp) {
                      showFooterAgreements(true, 'tncs');
                    } else {
                      window.open('https://compareyourfootprint.com/software-license-agreement/');
                    }
                  }}
                  style={{ cursor: 'pointer', border: 0, background: 'inherit' }}>
                  Terms &amp; Conditions <i className='bi bi-123'></i>
                </button>
              </span>

              <div style={{ clear: 'both' }}></div>
            </footer>
            <div style={{ display: 'flex' }}>
              {domain !== 'app' && !isWhiteLabelApp && hostname !== 'archerirm.compareyourfootprint.com' && (
                <div className='fixed bottom-0 text-white domain-bar text-center text-2xl px-4 py-2 font-bold z-10 bg-red-600'>
                  <span className='text-center'>You are currently on the {domain} version of CYF</span>
                </div>
              )}
              <ConditionalBetaBar />
            </div>
          </main>

          <HelpSidebar />
          </div>
        </Router>
      </TooltipProvider>
  );
}

const mapStateToProps = (state) => {
  const isFooterAgreementOpen = state.footerAgreements?.status;
  const org = state.organisation?.details;
  const profile = state.profile?.details;

  const registerPage = window.location.pathname.includes('register');
  const xeroOrSageCallback = ['xero', 'sage'].some((path) => window.location.pathname.includes(`${path}/callback`));

  // This array will be mapped to the admin portal tables -> Add here future admin portal tables
  const adminPortalTables = [
    'profiles',
    'entities',
    'industries',
    'industrySubcategory',
    'userPermissions',
    'reports',
    'seaDistances',
    'airports',
    'help',
    'electricitySources',
    'countries',
    'scope3Categories',
    'marketFactors',
    'subentities',
    'seatType',
    'vehicleType',
    'fuelType',
    'productionType',
    'loadType',
    'wasteType',
    'priceType',
    'originlocation',
    'finallocation',
    'factorprovider',
    'metrics',
    'facilities',
    'facilitiesType',
    'organisationMetrics',
    'benchmark',
    'addOns',
    'addOnProducts',
    'settings',
    'organisations',
    'usageTypeDetails',
    'organisationHierarchy',
    'integrationMappings',
    'currencies',
    'features',
    'currency-rates',
    'stripe',
    'secrFuelConversions',
    'factorSource',
    'orgTargets',
  ];

  return {
    hasContractPerm: profile?.permissions?.portal?.includes('CONTRACT') || false,
    checkedUsage: state?.admin?.checkboxes?.checkedUsage,
    branding: state.branding,
    brandingAssetPreview: state.brandingAssetPreview,
    showSidebar: state.sidebar.show,
    showHelpSidebar: state.help.show,
    isWhiteLabelApp: state?.whiteLabelAdmin?.whiteLabelId !== '0',
    cyfAdmin: profile?.cyfAdmin,
    ambassadorAdmin: profile?.ambassadorAdmin,
    whiteLabelAdmin: profile?.whiteLabelAdmin,
    consultantAdmin: profile?.consultantAdmin,
    canEditAdminPortal: profile?.permissions?.portal?.includes('EDIT_ADMIN'),
    whiteLabelAdminOrgs: state.admin?.whiteLabelAdminOrgs,
    loggedIn: profile ? true : false,
    credentialsObtained: profile?.credentials ? true : false,
    currentOrganisation: state.currentOrganisation,
    softwareLicenseAgreementConfirmed: profile?.legalAgreements?.softwareLicenseAgreementConfirmed,
    isFooterAgreementOpen,
    hasSubscriptionActive: hasUsableSubscription(org),
    canManageOrganisation: !!state?.organisation?.permissions?.organisation?.manage,
    adminPortalModal: state.admin?.modal?.adminPortalModal ? true : false,
    adminPortalConfirmationModal: state.admin?.modal?.confirmationModal ? true : false,
    notAutoClose: state.admin?.modal?.notAutoClose,
    registerPage,
    xeroOrSageCallback,
    processingStepFunction: state.processingImport?.status,
    orgDetails: state.organisation?.details,
    adminPortalTables,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getProfile: () => dispatch(PROFILEACTIONS.getProfile()),
  getReferralCode: () => dispatch(PROFILEACTIONS.getReferralCode()),
  listOrganisations: () => dispatch(ORGANISATIONACTIONS.listOrganisations()),
  listCountries: () => dispatch(ORGANISATIONACTIONS.listCountries()),
  listIndustries: () => dispatch(ORGANISATIONACTIONS.listIndustries()),
  listCurrencies: () => dispatch(ORGANISATIONACTIONS.listCurrencies()),
  getLegalCatalogue: () => dispatch(LEGALACTIONS.getLegalCatalogue()),
  getLegalStatus: () => dispatch(LEGALACTIONS.getLegalStatus()),
  getOrganisationMetrics: () => dispatch(ORGANISATIONACTIONS.getOrganisationMetrics()),
  getWLAdminOrgs: () => dispatch(ORGANISATIONACTIONS.getWLAdminOrgs()),
  getOrganisationUsers: () => dispatch(ORGANISATIONACTIONS.getOrganisationUsers()),
  getOrganisationPermissions: () => dispatch(ORGANISATIONACTIONS.getOrganisationPermissions()),
  getWLAdminSettings: () => dispatch(ORGANISATIONACTIONS.getWLAdminSettings()),
  toggleOrgModal: (status, item, action) => dispatch(ORGANISATIONACTIONS.toggleModal(status, item, action)),
  checkReportingYearEndIssue: (currentOrganisation) =>
    dispatch(ORGANISATIONACTIONS.checkReportingYearEndIssue(currentOrganisation)),
  listFacilityTypes: () => dispatch(FACILITYACTIONS.getFacilityTypes()),
  getFacilities: () => dispatch(FACILITYACTIONS.getFacilities()),
  getMetrics: () => dispatch(METRICACTIONS.getMetrics()),
  getAdminOrganisations: () => dispatch(ADMINACTIONS.getAdminOrganisations()),
  isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  loginWithAws: (username) => dispatch(AUTHENTICATIONACTIONS.loginWithAws(username)),
  getUserCredentials: () => dispatch(AUTHENTICATIONACTIONS.getUserCredentials()),
  getWLSettings: () => dispatch(AUTHENTICATIONACTIONS.getWLSettings()),
  getLicenses: () => dispatch(ACTIONS.getLicenses()),
  getStepFunctionStatus: (importArn) => dispatch(ACTIONS.getStepFunctionStatus(importArn)),
  getEntities: () => dispatch(ACTIONS.getEntities()),
  getSubentities: () => dispatch(ACTIONS.getSubentities()),
  showFooterAgreements: (status, agreement) => dispatch(ACTIONS.showFooterLegalAgreements(status, agreement)),
  whitelabelApp: (status) => dispatch(ACTIONS.whitelabelApp(status)),
  toggleModal: (status, action, item, notAutoClose) =>
    dispatch(ADMINACTIONS.toggleModal(status, action, item, notAutoClose)),
  getTypes: () => dispatch(METRICACTIONS.getTypes()),
  getScope3Categories: () => dispatch(METRICACTIONS.getScope3Categories()),
  getStripeCustomerId: () => dispatch(PAYMENTACTIONS.getStripeCustomerId()),
  getSubscription: () => dispatch(PAYMENTACTIONS.getSubscription()),
  getFeatures: () => dispatch(ACTIONS.getFeatures()),
  getAnnouncements: () => dispatch(ACTIONS.getAnnouncements()),
  getTargets: () => dispatch(DASHBOARDACTIONS.getTargets()),
  getDashboardComponents: () => dispatch(DASHBOARDACTIONS.getDashboardComponents()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
